import shortid from 'shortid';
import RuleActionModel from '@/common/models/rules/actions/rule-action-model';
import BindModel from '@/common/models/rules/bind-model';

export function buildInvoiceIssuedBind(
    {
        credentialHash,
    },
) {
    return new BindModel({
        status: BindModel.Statuses.active,
        name: 'Infusionsoft Order',
        labels: [`keap-infusionsoft:${shortid.generate()}`],
        actions: [{
            name: RuleActionModel.Names.createKeapInfusionsoftOrder,
            status: RuleActionModel.Statuses.active,
            credentialHash,
            orderBody: {
                order_date: '{{invoice.issuedTime}}',
                order_title: '{{invoice.id}}',
                order_type: 'Offline',
            },
            contactBody: {
                email_addresses: [
                    {
                        email: '{{ invoice.customer.email }}',
                        field: 'EMAIL1',
                    },
                ],
            },
        }],
    });
}

export function buildInvoicePaidBind(
    {
        credentialHash,
    },
) {
    return new BindModel({
        status: BindModel.Statuses.active,
        name: 'Infusionsoft Payment',
        labels: [`keap-infusionsoft:${shortid.generate()}`],
        actions: [{
            name: RuleActionModel.Names.createKeapInfusionsoftPayment,
            status: RuleActionModel.Statuses.active,
            credentialHash,
            paymentBody: {
                charge_now: false,
                date: '{{invoice.paidTime}}',
                payment_amount: '{{invoice.amount}}',
            },
        }],
    });
}
